module.exports = "<div class=\"container\"><p>FIAPI v0.2.13</p></div>"


//////////////////
// WEBPACK FOOTER
// ./client/components/footer/footer.pug
// module id = 48
// module chunks = 0